import { Tooltip, Modal, Button } from "antd";
import React from "react";
import defaultProductPic from "../../images/default-brand.jpg";
import { gotoPdp } from "Utils/activityHelper";
import { formatPrice } from "Utils/common";
const BundleProductCard: React.FC<{
    product: {};
    previewFlag: boolean;
    loginState: any;
}> = (props: any) => {
  const {
    product,
    loginState,
    previewFlag,
  } = props;

  const [showGoModal, setShowGoModal] = React.useState(false);

  const doGoPdp = () => {
    gotoPdp(product, loginState, 'Bundle_Detail');
  };
  
  return (
    <div className="productCardWrapper">
      <div className="productCard">
        <div className="top">
          <div className="line line1">
            <span>{product.sku}</span>
            <span
              dangerouslySetInnerHTML={{ __html: product.productSize }}
            ></span>
          </div>
          {product.productName ? <Tooltip
            title={
              <div
                dangerouslySetInnerHTML={{ __html: product.productName }}
              ></div>
            }
            trigger={"hover"}
          >
            <div
              className={
                product.pdpViewable ? "line line2 linkable" : "line line2"
              }
              onClick={() => {
                console.log("product card clicked");
                if (!product.pdpViewable) {
                  // 可选：message.info("该产品暂无详情页");
                  return;
                }
                setShowGoModal(true);
              }}
              dangerouslySetInnerHTML={{ __html: product.productName }}
            ></div>
          </Tooltip> : <div
              className={
                product.pdpViewable ? "line line2 linkable" : "line line2"
              }
              onClick={() => {
                console.log("product card clicked");
                if (!product.pdpViewable) {
                  // 可选：message.info("该产品暂无详情页");
                  return;
                }
                setShowGoModal(true);
              }}
            > </div>}
          {product.description && (
            <Tooltip title={product.description} trigger={"hover"}>
              <div
                className="line line3"
                dangerouslySetInnerHTML={{ __html: product.description }}
              ></div>
            </Tooltip>
          )}
          <div className="line line4" style={{
            alignItems: "center",
          }}>
            <div className="imgWrapper">
              <img
                alt={product.productName}
                src={product.productPic || defaultProductPic}
                onClick={() => {
                  if (!product.pdpViewable) {
                    // 可选：message.info("该产品暂无详情页");
                    return;
                  }
                  setShowGoModal(true);
                }}
              ></img>
            </div>
           <div className="priceWrapper">
            <div className="priceItem lightText lineThrough">{formatPrice(product.listPrice)}</div>
            <div className={previewFlag ? "lightText priceItem": "primaryText priceItem"}>{formatPrice(product.finalPrice)}</div>
            <div>X {product.componentQuantity}</div>
           </div>
          </div>
        </div>
      </div>
      <Modal
        title="提示"
        open={showGoModal}
        getContainer={document.body}
        onCancel={() => setShowGoModal(false)}
        style={{top: '35%'}}
        className="show-go-to-detail-info-modal"
        footer={[
          <Button
            key="ok"
            onClick={() => {
              setShowGoModal(false);
              doGoPdp();          // 确认后再走原逻辑
            }}
          >
            继续前往
          </Button>,
          <Button key="cancel" type="primary" onClick={() => setShowGoModal(false)}>
            留在本页
          </Button>,
        ]}
      >
      <p>该促销仅限当前页面加购才可享受，浏览产品详情后需返回本页面参与。</p>
    </Modal>
    </div>
  );
};

export default BundleProductCard;
